module.exports = __webpack_public_path__ + "img/4C.a52ea384.png";